var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-5 pt-2 pb-8 min-h-[166px] flex items-center justify-center"},[(_setup.titleLogo)?_c('img',{staticClass:"h-[38px] max-w-full",attrs:{"src":_setup.titleLogo,"alt":""}}):_c('div',{staticClass:"text-[28px] max-w-full break-all title"},[_vm._v(" "+_vm._s(_setup.titleText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }